
import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { DatePickerDirective } from '../../directives/datepicker.directive';
import { MdPaginator, MdSnackBar, MdDialog, DateAdapter, MdDatepickerModule } from "@angular/material";
import { DataSource } from "@angular/cdk/collections";
import { IncassoListItemModel } from "../../models/incassi/incasso-list-item.model";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';

import { IncassiDettaglioService } from "../../services/incassi-dettaglio.service";
import { IncassiService } from "../../services/incassi.service";
import { DizionarioModel } from "../../models/shared/dizionario.model";
import { BrogliaccioDistintaModel } from "../../models/brogliacci/brogliaccio-distinta.model";
import { IncassoContantiListItemModel } from "../../models/incassi/incasso-contanti-list-item.model";
import { IncassoAssegniListItemModel } from "../../models/incassi/incasso-assegni-list-item.model";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { DistintaContantiDialogConfigModel, DistintaContantiDialog } from "../incassi/distinta-contanti.component";
import { DistintaAssegniDialogConfigModel, DistintaAssegniDialog } from "../incassi/distinta-assegni.component";
import { DistinteVersamentiService } from "../../services/distinte-versamenti.service";
import { DistinteIncassiService } from "../../services/distinte-incassi.service";
import { Configurations } from "../../core/configurations";
import { BancheItemsModel } from "../../models/brogliacci/banche.model";
import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IncassoModel } from '../../models/incassi/incasso.model';
import { isNullOrUndefined } from 'util';
import { UltimaVersioneApplicativoClientService } from '../../services/ultima-versione-applicativo-client.service';
import { NotificationModel } from '../../models/shared/notificationModel.model';

///////////////////////
//TODO:
//1- posizione delle immagini degli assegni e del documento di versamento
//////////////////////

@Component({
  selector: 'app-distinta-versamenti-detail',
  templateUrl: './distinta-versamenti-detail.component.html',
  styleUrls: ['./distinta-versamenti-detail.component.css']
})

export class DistintaVersamentiDetailComponent implements OnInit {
  activatedRoute: any;
  //distinta versamenti
  distintaCorrente: BrogliaccioDistintaModel;

  //distinta incassi della distinta versamenti - non usato:
  //distinteIncassi: BrogliaccioDistintaModel[];

  //per controllo assegni tutti verificati
  numeroAssegni: number;
  numeroAssegniSelezionati: number;
  showConferma: boolean;
  //dettaglio assegno
  showAssegno: boolean;
  tokenShowAssegno: string;
  pathImgA: string;
  pathImgD: string;
  pathImg = 'assets/img/';
  //banca selezionata
  //banca: DizionarioModel;
  //bancaSel?: string;
  //nomeBancaSel: string;
  //abiBanca?: number;
  //cabBanca?: number;
  banche: BancheItemsModel[];
  //file upload
  fileList: FileList;
  isLoading: boolean;
  isClosing: boolean=false;
  assegnoSelezionato:IncassoAssegniListItemModel;
  assegnoSelezionatoFileChanged=false;
  savingF:boolean;
  savingR:boolean;
  constructor(
    private configuration: Configurations,
    private _distinteIncassiService: DistinteIncassiService,
    private _distintaService: DistinteVersamentiService,
    private _incassiService: IncassiService,
    private _incassiDettaglioService: IncassiDettaglioService,
    private snackBar: MdSnackBar,
    private route: ActivatedRoute,
    private distintaContantiDlg: MdDialog,
    private distintaAssegniDlg: MdDialog,
    private router: Router,
    private sanitizer: DomSanitizer,
    private _dateAdapter:DateAdapter<Date>,
    private _ultimaVersioneClientTipo:UltimaVersioneApplicativoClientService
  ) { 
    _dateAdapter.setLocale('it-IT');
  }
  imageToShowF: any;
  imageToShowR: any;
  isAImageLoading: boolean;  
  imageToShow: any;
  isImageLoading: boolean;

  ngOnInit() {
    //alert("pagina dettaglio distinta versamenti");
    this._ultimaVersioneClientTipo.getUltimaVersioneApplicativo()
    .subscribe(data => {
      Configurations.currentVersionCod=data.codice;
      let v=localStorage.getItem('clientVersion');
      if(v===null||v===undefined||v!==data.codice) {
        localStorage.setItem('clientVersion',data.codice);
        alert("Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage.");
        window.location.href=Configurations.baseUrl;
        
      }
    });
    //this.distinteIncassi = [];
    this.isLoading = true;
    this.numeroAssegni = 0;
    this.numeroAssegniSelezionati = 0;
  
    let main = this;
    this.route.paramMap
      .switchMap((params: ParamMap) =>
        this._distintaService.get(params.get('gid')))
        .finally(() => {
          this.isLoading = false;
         } )
      .subscribe(
      d => {
        this.distintaCorrente = d;
        let numeroAssegniDistinta=0;
        let numeroAssegniValidati=0;
        this.distintaCorrente.incassi.map(function(f) {
          main.numeroAssegni += f.assegni.length;
          numeroAssegniDistinta=main.numeroAssegni;
          numeroAssegniValidati += f.assegni.filter(asel => asel.flagAssegnoVerificato === true).length;
        });
        main.numeroAssegniSelezionati =numeroAssegniValidati;
        this.showConferma = this.distintaCorrente.stato.id === 1 &&
        ( (numeroAssegniDistinta === this.numeroAssegniSelezionati)||numeroAssegniDistinta===0);
        this.getImageFromService();
        if(this.distintaCorrente.stato.id!==3) {
        this._distintaService.getBanche().subscribe(
          (data: BancheItemsModel[]) => {
            this.banche = data;
            if(data.length>0) {
              this.distintaCorrente.idBanca=data[0].codice;
            }
            this.isLoading=false;
          }
        );
        } else {
          this.isLoading=false;
        }
        console.log(this.distintaCorrente.dataPresaInCarico);
        
      },
      error => {
        this.showError("Errore durante il caricamento delle informazioni");
      }
      );
  }

  /* TOTALI degli incassi delle distinte I della distinta V */
  totaleMonete(listaContanti: IncassoContantiListItemModel[]): number {
    let tot = 0;
    if (!listaContanti) { return 0; }

    listaContanti.forEach(c => {
      if (c.idTaglio === 8 && c.importo != null) {
        tot = tot + c.importo;
      }
    });
    return tot;

  }

  totaleBanconote(listaContanti: IncassoContantiListItemModel[]): number {
    let tot = 0;
    if (!listaContanti) { return 0; }
    listaContanti.forEach(c => {
      if (c.idTaglio !== 8 && c.importo != null) {
        tot = tot + c.importo;
      }
    });
    return tot;
  }

  /* CONFERMA: fatta successivamente alla fase di verifica degli assegni 
     non è ancora chiusa in quando devono essere caricate le info del versamento in banca
  */
  confermaDistinta(): void {
    this.isLoading=true;
    if (this.distintaCorrente.stato.id !== 1) {
      this.snackBar.open("Errore. La distinta non può essere confermata.", 'Chiudi', { duration: 1000 });
    } else {
      this._distintaService.confermaDistintaVersamenti(this.distintaCorrente).subscribe(
        data => {
          if(data.result) {
            this.showInfo("Conferma avvenuta correttamente");
            this.distintaCorrente.stato = new DizionarioModel();
            this.distintaCorrente.stato.id = 2; //il conferma significa in questo caso Verificata
            this.isLoading=false;
            this.ngOnInit();
          } else {
            this.isLoading=false;
            this.showError(data.message);
            
          }

        },
        error => {
          this.showError("Errore durante la procedura di conferma");
          this.isLoading=false;
          return false;
        }
      );
    }
  }

  /* SALVA: VERIFICA ASSEGNO */
  salva() {
    this.numeroAssegniSelezionati = 0;
    this.isLoading=true;
    let toSubScribe:number = this.numeroAssegni;
    this.distintaCorrente.incassi.forEach(i => {
      i.assegni.forEach(ass => {
        if (ass.flagAssegnoVerificato === true) {
          this.numeroAssegniSelezionati++;
          this._incassiDettaglioService.verificaAssegno(ass.token).subscribe(
            data => {
              this.showInfo("Verifica avvenuta correttamente");
              toSubScribe--;
              if(toSubScribe===0) {
                this.isLoading=false;
              }
            },
            error => {
              this.showError("Errore durante la verifica dell'assegno");
              toSubScribe--;
              if(toSubScribe===0) {
                this.isLoading=false;
              }
              return false;
            }
          );
          this.showConferma = this.distintaCorrente.stato.id === 1 && 
          ((this.numeroAssegni === this.numeroAssegniSelezionati) || this.numeroAssegni === 0);
          
        } else {
          toSubScribe--;
          if(toSubScribe===0) {
            this.isLoading=false;
          }
        }

      });
    });
    if(toSubScribe===0) {
      this.isLoading=false;
    }
  }

  changeShowAssegni(assegno: IncassoAssegniListItemModel) {
    if(this.assegnoSelezionatoFileChanged) {
      if(!confirm("Le modifiche effettuate verranno perse, continuare?")) {
        return;
      } else {
        this.assegnoSelezionatoFileChanged=false;
      }
    }
    if (!assegno) {
      this.showAssegno = false;
      this.tokenShowAssegno = "";
      this.assegnoSelezionato=null;
      this.assegnoSelezionatoFileChanged=false;
      return;
    }
    this.showAssegno = this.tokenShowAssegno !== assegno.token;
    this.tokenShowAssegno = this.showAssegno === false ? "" : assegno.token;
    //if (this.showAssegno == true) 
    //{
      this.getAImageFromService("F", assegno.token);
      this.getAImageFromService("R", assegno.token);
      this.assegnoSelezionato=assegno;
    //}
  }

  includi(row: IncassoAssegniListItemModel) {
    this.distintaCorrente.incassi.forEach(i => {
      let assegnoInteressato=i.assegni.find(ass => ass.token === row.token);
      if (assegnoInteressato) {
        assegnoInteressato.flagAssegnoVerificato = row.flagAssegnoVerificato;
      }
      i.assegni.forEach(ass=> {
        console.log(ass.flagAssegnoVerificato);
      });
    });
  }

  /* ELIMINAZIONE DELLA DISTINTA CORRENTE*/
  eliminaDistintaVersamenti() {
    //elimino la distinta versamenti(dalla lista) ed esco
    this._distintaService.eliminaDistinta(this.distintaCorrente).subscribe(

      (data: any) => {
        //verifica esito e redirect 
        if (data.result.result === false) {
          this.showError(data.result.message);
          return false;
        } else {
          this.showInfo("Eliminazione avvenuta correttamente");
          this.router.navigateByUrl('/distinteversamenti');
        }
      },
      error => {
        this.showError("Errore durante la procedura di eliminazione della distinta");
        return false;
      }

    );

  }

  /* UPLOAD FILE E CHIUSURA VERSAMENTO */
  fileChange(event) {
    this.fileList = event.target.files;
  }

  assegnoFileChange(event, id) {
    
    this.assegnoSelezionatoFileChanged=true;
    if (id === 1) {
      this.assegnoSelezionato.imgFronte = event.target.files;
    }
    if (id === 2) {
      this.assegnoSelezionato.imgRetro = event.target.files;
    }
    
  }
  disableUploadAssegnoImages() {
    return !(this.assegnoSelezionato!=null && !this.assegnoSelezionato.flagAssegnoVerificato);
  }
  disableSaveFilesAssegno() {
    let result=!(this.assegnoSelezionatoFileChanged && this.assegnoSelezionato!=null && !this.assegnoSelezionato.flagAssegnoVerificato) ;
  }
  salvaFileAssegnoSelezionato() {
    if(this.assegnoSelezionatoFileChanged) {
      this.isLoading=true;
      if(this.assegnoSelezionato.imgFronte) {
        this.savingF=true;
        let fileF: File = this.assegnoSelezionato.imgFronte[0];
        let formDataF: FormData = new FormData();
        formDataF.append('file', fileF, fileF.name);
        formDataF.append('TokenProprietario', this.assegnoSelezionato.token);
        formDataF.append('idAllegatoTipo', '5');
        formDataF.append('FronteRetro', 'F');
        this._incassiDettaglioService.uploadImmagineAssegno(formDataF).subscribe(
          (data: any) => {
            this.savingF=false;
            this.isLoading=(this.savingF||this.savingR);
            if(!this.isLoading) {
              this.showInfo("Immagini caricate");
            }
          },
          error => {
            //this.showError("Errore durante la procedura di upload delle immagini");
            //return false;
            this.savingF=false;
            this.isLoading=(this.savingF||this.savingR);
            if(!this.isLoading) {
              this.showInfo("Errore nel salvataggio delle immagini");
            }
          }
        );
      }
      if(this.assegnoSelezionato.imgRetro) {
        this.savingR=true;
        let fileR: File = this.assegnoSelezionato.imgRetro[0];
        let formDataR: FormData = new FormData();
        formDataR.append('file', fileR, fileR.name);
        formDataR.append('TokenProprietario', this.assegnoSelezionato.token);
        formDataR.append('idAllegatoTipo', '5');
        formDataR.append('FronteRetro', 'R');
        this._incassiDettaglioService.uploadImmagineAssegno(formDataR).subscribe(
          (data: any) => {
            this.savingR=false;
            this.isLoading=(this.savingF||this.savingR);
            if(!this.isLoading) {
              this.showInfo("Immagini caricate");
            }
          },
          error => {
            this.savingR=false;
            this.isLoading=(this.savingF||this.savingR);
            //this.showError("Errore durante la procedura di upload delle immagini");
            //return false;
            if(!this.isLoading) {
              this.showInfo("Errore nel salvataggio delle immagini");
            }
          }
        );
      }
      this.assegnoSelezionatoFileChanged=false;
      this.assegnoSelezionato=null;
      this.changeShowAssegni(null);
    }
  }
  checkChiudiDati(): boolean {

    let retV=true;
    if (!this.distintaCorrente.idBanca) {
      this.showError("Indicare la banca dove è avvenuto il versamento");
      retV=false;
    }
    if (!this.distintaCorrente.dataPresaInCarico) {
      this.showError("Indicare la data del versamento");
      retV=false;
    }
    if (this.distintaCorrente.dataPresaInCarico > new Date()) {
      this.showError("La data del versamento deve essere precedente o uguale alla data odierna");
      retV=false;
    }
    if (!this.distintaCorrente.numeroOperazione) {
      this.showError("Indicare il numero di operazione del versamento");
      retV=false;
    }
    if(!retV) {
      this.isLoading=false;
      this.isClosing=false;
    }
    return retV;
  }

  chiudiDistinta() {
    if(this.isClosing) {
      this.showError("Chiusura già in corso");
      return;
    }
    this.isClosing=true;
    this.isLoading=true;
    //campi obbligatori per la chiusura: banca, operaizone e data versamento
    if (this.checkChiudiDati()) {
      //il file non è più obbligatorio:
      if (!this.fileList) {
        this._distintaService.chiudiDistintaVersamenti(this.distintaCorrente).subscribe(
          (data: NotificationModel) => {
            if (data.result === false) {
              this.showError(data.message);
              this.isLoading=false;
              return false;
            } else {
              if(data.message && data.message!=='') {
                this.showInfo(data.message);
              } else {
                this.showInfo("Chiusura avvenuta correttamente");
              }
              this.ngOnInit();
            }
            this.isLoading=false;
            this.isClosing=false;
          },
          error => {
            this.showError("Errore durante la procedura di chiusura");
            this.isLoading=false;
            this.isClosing=false;
            return false;

          }
        );
      } else
        //se ho il file caricato allora carico e chiudo
        if (this.fileList.length > 0) {

          let file: File = this.fileList[0];
          let formData: FormData = new FormData();
          formData.append('file', file, file.name);
          formData.append('TokenProprietario', this.distintaCorrente.token);
          formData.append('idAllegatoTipo', '5');

          this._distintaService.uploadDocumentoVersamento(formData, this.distintaCorrente).subscribe(
            (data: any) => {

              // if (data.result.result === false) {
              //   this.showError(data.result.message);
              //   return false;
              // } else {

              this._distintaService.chiudiDistintaVersamenti(this.distintaCorrente).subscribe(
                (res: any) => {
                  if (!res.result.result) {
                    this.showError(res.result.message);
                    return false;
                  } else {
                    this.isLoading=false;
                    this.showInfo("Conferma avvenuta correttamente");
                    this.ngOnInit();
                    this.isLoading=false;
                    this.isClosing=false;
                  }
                },
                error => {
                  this.showError("Errore durante la procedura di conferma");
                  this.isLoading=false;
                  this.isClosing=false;
                  return false;
                }
              );
            },
            error => {
              this.showError("Errore durante la procedura di conferma");
              this.isLoading=false;
              this.isClosing=false;
              return false;
            }
          );
        }
    }
  }


  /* STAMPA  */
  stampaDistinta() {
    //ritorna il pdf 

    let self = this;

    // Status flag used in the template.
    let pending = true;

    // Create the Xhr request object
    let xhr = new XMLHttpRequest();
    let preurl = this.configuration.apiBaseUrlStampe;
    let MethodPrint = "printDV";
    let url = preurl + MethodPrint + "/" + this.distintaCorrente.token;
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    let scope = this;
    // Xhr callback when we get a result back
    // We are not using arrow function because we need the 'this' context
    xhr.onreadystatechange = function () {

      // We use setTimeout to trigger change detection in Zones
      setTimeout(() => { pending = false; }, 0);

      // If we get an HTTP status OK (200), save the file using fileSaver
      if (xhr.readyState === 4 && xhr.status === 200) {
        let blob = new Blob([this.response], { type: 'application/pdf' });
        //fileSaver.saveAs(blob, 'Report.pdf');
        if(window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob,"distinta versamenti " + scope.distintaCorrente.id+".pdf");
        } else {
          let blobUrl = window.URL.createObjectURL(blob);
          window.open(blobUrl);
        }
      }
    };

    // Start the Ajax request
    xhr.send();
  }

  /* VISUALIZZA IMMAGINE CARICATA  DISTINTA*/

  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.imageToShow = this.sanitizer.bypassSecurityTrustResourceUrl(reader.result);
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }
  getImageFromService() {
    this.isImageLoading = true;
    this._distintaService.getFileImage(this.distintaCorrente.token).subscribe(data => {
      this.createImageFromBlob(data);
      this.isImageLoading = false;
    }, error => {
      this.isImageLoading = false;
    });
  }


  /* IMMAGINE ASSEGNO */


  createAImageFromBlob(image: Blob, fronteretro: string) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      if (fronteretro === "F") {
        this.imageToShowF = this.sanitizer.bypassSecurityTrustResourceUrl(reader.result);
      } else {
         this.imageToShowR = this.sanitizer.bypassSecurityTrustResourceUrl(reader.result);
      }
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }
  getAImageFromService(fronteretro: string, tokenAssegno: string) {
    this.isImageLoading = true;
    this._incassiDettaglioService.getFileImage(tokenAssegno, fronteretro).subscribe(data => {
      this.createAImageFromBlob(data, fronteretro);
      this.isImageLoading = false;
    }, error => {
      this.isImageLoading = false;
    });
  }


  /* BANCHE e VERSAMENTI */
  /*
  onSearchChange(searchValue: string) {

    if (this.abiBanca && this.cabBanca) {
      this._distintaService.getBancaByAbiCab(this.abiBanca, this.cabBanca)
        .subscribe(
        data => {
          this.banca = data;
          this.nomeBancaSel = data.descrizione;
          this.bancaSel = data.id;
          this.distintaCorrente.idBanca = data.id;
        },
        err => {
          this.banca = null;
          this.bancaSel = null;
          this.nomeBancaSel = "";
          this.distintaCorrente.idBanca = null;
          this.showError("Errore nella ricerca delle banche");
        }

        );
    } else {
      this.banca = null;
      this.bancaSel = null;
      this.nomeBancaSel = "";
      this.distintaCorrente.idBanca = null;
    }

  }*/

  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 10000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 10000 });
  }

  openDistintaContanti(incassoCorrente: IncassoModel) {
    let dlgRef = this.distintaContantiDlg.open(DistintaContantiDialog,
      { data: new DistintaContantiDialogConfigModel(incassoCorrente, false) })
      .afterClosed().subscribe((res: IncassoModel) => {

      });
  }

  openDistintaAssegni(incassoCorrente: IncassoModel) {
    let dlgRef = this.distintaAssegniDlg.open(DistintaAssegniDialog,
      { data: new DistintaAssegniDialogConfigModel(incassoCorrente, false), width: '80%' })
      .afterClosed().subscribe((res: IncassoModel) => {
      });
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/distinteVersamenti/distinta-versamenti-detail.component.ts